export default [
  {
    // 공통 팝업
    path: 'common',
    children: [
      {
        // 회원상세 팝업
        path: 'member-detail',
        name: 'MemberDetailPopup',
        meta: { keepAlive: false },
        component: () => import('@/pages/reportMng/common/popup/MemberDetailPopup.vue')
      },
      {
        // 영수증/전표 팝업
        path: 'receipt-bill',
        name: 'ReceiptBillPopup',
        meta: { keepAlive: false, layout: 'blank' },
        component: () => import('@/pages/reportMng/common/popup/ReceiptBillPopup.vue')
      },
      {
        // 마감관리 팝업 (강습)
        path: 'lect-daily-report-popup',
        name: 'LectDailyReportPopup',
        meta: { keepAlive: false },
        component: () => import('@/pages/reportMng/common/popup/LectDailyReportPopup.vue')
      },
      {
        // 상세검색 팝업
        path: 'detail-search',
        name: 'DetailSearchPopup',
        meta: { keepAlive: false, layout: 'blank' },
        component: () => import('@/pages/reportMng/common/popup/DetailSearchPopup.vue')
      }
    ]
  }
]
